import React from 'react';
import { motion } from 'framer-motion';
import FAQ from '../sections/FAQ.js';
import { pageWrapperStyle } from '../../styles/pageStyles.js';

const FAQPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ ...pageWrapperStyle, paddingTop: 0 }}
    >
      <FAQ />
    </motion.div>
  );
};

export default FAQPage;
